import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import "../../../css/mobile-intro/mobile-intro.css";
import { postDcSelDailyCheckDetail, postDcSelDCBCDate } from "../../../api/dailyCheck";
import { toast } from "wc-toast";
import Loading from "../../../componant/loading/Loading";
import BlockchainDetailModal from "../../../componant/modal/BlockchainDetailModal";

export default function DailyCheckHistory() {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const paramDate = searchParams.get("date");
    const [searchDate, setSearchDate] = useState(
        paramDate || location.state?.date || dayjs().format("YYYY-MM-DD")
    );

    const [detailData, setDetailData] = useState(null);
    const [loading, setLoading] = useState(true);

    const [bcModalOpen, setBcModalOpen] = useState(false);
    const [bcLoading, setBcLoading] = useState(false);
    const [bcData, setBcData] = useState(null);

    const callPostDcSelDailyCheckDetail = async (targetDate) => {
        setLoading(true);
        try {
            const response = await postDcSelDailyCheckDetail({ check_date: targetDate });
            if (response?.code === 1000 && response?.result) {
                setDetailData(response.result);
            } else {
                setDetailData(null);
            }
        } catch (err) {
            console.error("상세 정보 조회 실패:", err);
            toast.error("데이터를 불러오는 중 오류가 발생했습니다.");
            setDetailData(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (searchDate) {
            callPostDcSelDailyCheckDetail(searchDate);
        }
    }, [searchDate]);

    const handleGoToEdit = () => {
        navigate(`/inspection/daily_check?date=${searchDate}`);
    };

    const handleShowBlockchain = async () => {
        if (!detailData?.tx_id) {
            toast.error("블록체인 데이터를 확인할 수 없습니다.");
            return;
        }

        setBcLoading(true);
        try {
            const response = await postDcSelDCBCDate({ tx_id: detailData.tx_id });

            if (response?.code === 1000) {
                setBcData(response);
                setBcModalOpen(true);
            } else {
                toast.error("블록체인 원장 정보를 불러올 수 없습니다.");
            }
        } catch (err) {
            console.error("블록체인 조회 에러:", err);
            toast.error("블록체인 원장 조회 중 오류가 발생했습니다.");
        } finally {
            setBcLoading(false);
        }
    };

    const getStatusText = (itemCd) => {
        if (!detailData?.itemList) return "미운행";
        const found = detailData.itemList.find((sub) => sub.item_cd === itemCd);

        if (!found) return "미운행";
        if (found.check_flag === "G") return "양호";
        if (found.check_flag === "B") return "불량";
        if (found.check_flag === "N") return "미운행";
        return "미운행";
    };

    const renderStatus = (status) => {
        let textColor = "#212529";

        if (status === "양호") {
            textColor = "#1B7F4B";
        } else if (status === "불량") {
            textColor = "red";
        } else if (status === "미운행") {
            textColor = "#EAA135";
        }

        return (
            <span className="fw-bold" style={{ color: textColor }}>
                {status}
            </span>
        );
    };


    if (loading) return <Loading />;

    return (
        <div
            className="mobile-intro-wrapper"
            style={{
                background: "#F8F9FA",
                maxWidth: "600px",
                margin: "0 auto",
                width: "100%",
                minHeight: "100vh",
                height: "auto",
                padding: "65px 15px 50px 15px",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
            }}
        >
            <div className="d-flex align-items-center mb-3">
                <div className="w-100 bg-white rounded-3 p-3 d-flex align-items-center shadow-sm">
                    <div style={{ background: "#EBF3FF", width: "36px", height: "36px", borderRadius: "20%", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px" }}>
                        <img alt="" width="25" height="25" src={process.env.PUBLIC_URL + "/img/icon_registration_off.png"} />
                    </div>
                    <h4 className="m-0 fs-5 fw-bold" style={{ color: "#212529" }}>일일 점검표 확인</h4>
                </div>
            </div>

            <div className="d-flex gap-2 align-items-center mb-3">
                <span
                    className="badge d-inline-flex text-dark fw-bold align-items-center justify-content-center"
                    style={{
                        background: "#EAA135",
                        minWidth: "75px",
                        fontSize: "14px",
                        height: "36px"
                    }}
                >
                    점검일시
                </span>

                <input
                    type="text"
                    className="form-control fw-bold border-secondary-subtle text-center bg-light"
                    value={searchDate}
                    readOnly
                    style={{
                        borderRadius: "6px",
                        height: "36px",
                        cursor: "default",
                        pointerEvents: "none"
                    }}
                />

                <button
                    type="button"
                    onClick={handleGoToEdit}
                    className="btn text-white fw-bold"
                    style={{ background: "#3A74C2", borderRadius: "6px", height: "36px", minWidth: "65px", fontSize: "14px" }}
                >
                    수정
                </button>
            </div>

            <div className="bg-white rounded-2 p-3 shadow-sm border mb-3" style={{ minHeight: "320px", fontSize: "14px", color: "#333" }}>
                {detailData ? (
                    <div>
                        <p className="mb-1 fw-bold">점검일시 : {detailData.check_date}</p>
                        <p className="mb-1">운전자명 : {detailData.user_nm}</p>
                        <p className="mb-1">차량번호 : {detailData.veh_number}</p>
                        <p className="mb-3">사업자명 : {detailData.tb_nm}</p>
                        <hr className="my-3" style={{ color: "#DEE2E6" }} />

                        {(detailData.itemList || [])
                            .filter(item => item.check_yn === "N")
                            .map((category) => {
                                const subItems = (detailData.itemList || []).filter(sub => {
                                    if (sub.check_yn !== "Y") return false;
                                    const parentCdVal = sub.cd_val.split("-")[0];
                                    return parentCdVal === category.cd_val;
                                });

                                return (
                                    <div key={category.item_cd || category.cd_val} className="mb-4">
                                        <p className="fw-bold mb-2 text-dark" style={{ fontSize: "15px" }}>
                                            {category.cd_val}. {category.item_cd_nm}
                                        </p>

                                        <div className="d-flex flex-column gap-1 mb-2">
                                            {subItems.map((sub) => {
                                                const flagMap = { G: "양호", B: "불량", N: "미운행" };
                                                const statusText = flagMap[sub.check_flag];

                                                return (
                                                    <p key={sub.item_cd || sub.cd_val} className="mb-1 ps-2 text-secondary">
                                                        {sub.cd_val}. {sub.item_cd_nm} : {renderStatus(statusText)}
                                                    </p>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })
                        }

                        <hr className="my-3" style={{ color: "#DEE2E6" }} />
                        <p className="fw-bold mb-1">4. 불량상태 조치 기록</p>
                        <p className="ps-2 text-muted" style={{ whiteSpace: "pre-wrap" }}>
                            {detailData.check_msg}
                        </p>
                    </div>
                ) : (
                    <div className="d-flex align-items-center justify-content-center text-muted" style={{ height: "280px" }}>
                        해당 날짜에 등록된 점검 정보가 없습니다.
                    </div>
                )}
            </div>

            {/* {detailData && (
                <div>
                    <button
                        type="button"
                        onClick={handleShowBlockchain}
                        disabled={bcLoading}
                        className="btn text-white fw-bold d-flex align-items-center justify-content-center"
                        style={{ background: "#EAA135", borderRadius: "6px", height: "50px", minWidth: "100%", fontSize: "14px" }}
                    >
                        {bcLoading ? "블록체인 정보 조회 중..." : "블록체인 기록 보기"}
                    </button>
                </div>
            )} */}

            <BlockchainDetailModal
                isOpen={bcModalOpen}
                onClose={() => setBcModalOpen(false)}
                bcData={bcData}
            />
        </div>
    );
}